var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.is_login == false
        ? _c(
            "header",
            [
              _c(
                "Tooltip",
                {
                  staticClass: "setting_btn",
                  attrs: { placement: "bottom-end", content: _vm.$t("logout") }
                },
                [
                  _c("Icon", {
                    attrs: { type: "ios-log-out", id: "exit1" },
                    on: { click: _vm.logout }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Tooltip",
                {
                  staticClass: "setting_btn",
                  attrs: {
                    placement: "bottom-end",
                    content: _vm.$t("help_center")
                  }
                },
                [
                  _c("img", {
                    staticStyle: { display: "block", "margin-top": "3px" },
                    attrs: {
                      src: require("../static/images/header_help.svg"),
                      alt: ""
                    },
                    on: { click: _vm.showLittleHelp }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "Dropdown",
                {
                  staticStyle: { "margin-left": "20px", float: "right" },
                  attrs: { trigger: "click", id: "swtich_lang_dropdown1" },
                  on: { "on-click": _vm.switchLang }
                },
                [
                  _c(
                    "Button",
                    { attrs: { type: "primary" } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.current_lang) + "\n        "
                      ),
                      _c("Icon", { attrs: { type: "ios-arrow-down" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "DropdownMenu",
                    { attrs: { slot: "list" }, slot: "list" },
                    _vm._l(_vm.lang_list, function(item, index) {
                      return _c(
                        "DropdownItem",
                        {
                          key: index,
                          attrs: {
                            name: index,
                            id: "swtich_lang_dropdown1_" + index
                          }
                        },
                        [_vm._v(_vm._s(item) + "\n        ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "iconfont icon-emoment" })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "body", style: { height: _vm.pageHeight + "px" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "95vh",
                "overflow-y": "scroll",
                "padding-bottom": "100px"
              }
            },
            [
              _vm.is_login == false
                ? _c(
                    "Layout",
                    { style: { height: "100vh" } },
                    [
                      _c(
                        "Sider",
                        {
                          attrs: { collapsible: "", "collapsed-width": 70 },
                          model: {
                            value: _vm.isCollapsed,
                            callback: function($$v) {
                              _vm.isCollapsed = $$v
                            },
                            expression: "isCollapsed"
                          }
                        },
                        [
                          _c(
                            "Menu",
                            {
                              class: _vm.menuitemClasses,
                              attrs: {
                                theme: "light",
                                "open-names": _vm.openMenuArr,
                                width: "auto"
                              }
                            },
                            [
                              _vm.checkRole("basic")
                                ? _c(
                                    "Submenu",
                                    { attrs: { name: "basic" } },
                                    [
                                      _c(
                                        "template",
                                        {
                                          attrs: { id: "basic_data" },
                                          slot: "title"
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "ios-paper" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("t")("network_space")
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "zoom_room_list",
                                            to: "/MeetingRoomList",
                                            id: "conference_room"
                                          }
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "ios-apps" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "zoom_meeting_room"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("t")(
                                                    "zoom_meeting_room"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "live_room_list",
                                            to: "/LiveMeetingRoomList",
                                            id: "live_room"
                                          }
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "ios-apps" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "live_meeting_room"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("t")(
                                                    "live_meeting_room"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "tag_list",
                                            to: "/TagList",
                                            id: "dictionaries"
                                          }
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "ios-pricetag" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm._f("t")("tag")))
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "user",
                                            to: "/UserList",
                                            id: "user"
                                          }
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "ios-people" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("t")("partner_pool")
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "helpCenter",
                                            to: "/HelpCenter",
                                            id: "helpCenter"
                                          }
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "ios-book" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                title: _vm.$t("help_center")
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("t")("help_center")
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "notice",
                                            to: "/Notice",
                                            id: "notice"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../static/images/公告管理.svg"),
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("t")("notice")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "application",
                                            to: "/Application",
                                            id: "application"
                                          }
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "ios-apps-outline" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm._f("t")("application"))
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuGroup",
                                        { attrs: { title: "SETTINGS" } },
                                        [
                                          _c(
                                            "MenuItem",
                                            {
                                              attrs: {
                                                name: "admin",
                                                to: "/AdminList",
                                                id: "Administrator"
                                              }
                                            },
                                            [
                                              _c("Icon", {
                                                attrs: { type: "ios-person" }
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm._f("t")("admin"))
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "MenuItem",
                                            {
                                              attrs: {
                                                name: "report_list",
                                                to: "/ReportViewerList",
                                                id: "ReportViewer"
                                              }
                                            },
                                            [
                                              _c("Icon", {
                                                attrs: { type: "ios-person" }
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("t")(
                                                      "report_viewer.title"
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "MenuItem",
                                            {
                                              attrs: {
                                                name: "sensitive",
                                                to: "/SensitiveWords",
                                                id: "sensitive_word"
                                              }
                                            },
                                            [
                                              _c("Icon", {
                                                attrs: { type: "ios-quote" }
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("t")(
                                                      "chat_block_word"
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "MenuItem",
                                            {
                                              attrs: {
                                                name: "videoManage",
                                                to: "/VideoManage",
                                                id: "video_manage"
                                              }
                                            },
                                            [
                                              _c("Icon", {
                                                attrs: { type: "ios-videocam" }
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("t")("video_manage")
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "MenuItem",
                                            {
                                              attrs: {
                                                name: "channelManage",
                                                to: "/ChannelManage",
                                                id: "channel_manage"
                                              }
                                            },
                                            [
                                              _c("Icon", {
                                                attrs: { type: "md-pulse" }
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("channel_manage")
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkRole("event")
                                ? _c(
                                    "Submenu",
                                    { attrs: { name: "event" } },
                                    [
                                      _c(
                                        "template",
                                        {
                                          attrs: {
                                            id: "management_of_activities"
                                          },
                                          slot: "title"
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "ios-list-box" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("t")("event_management")
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "event_list",
                                            to: "/EventList",
                                            id: "activity"
                                          }
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "md-list" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm._f("t")("event")))
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkRole("basic")
                                ? _c(
                                    "Submenu",
                                    { attrs: { name: "sport_setting" } },
                                    [
                                      _c(
                                        "template",
                                        {
                                          attrs: { id: "sport_setting" },
                                          slot: "title"
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "md-football" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("sport_setting"))
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "MenuItem",
                                        {
                                          attrs: {
                                            name: "sport",
                                            to: "/Sport",
                                            id: "sport"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  "margin-right": "3px"
                                                },
                                                attrs: {
                                                  src: require("../static/images/sport.svg"),
                                                  width: "16",
                                                  height: "16"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("sport.name"))
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.report_list.length > 0
                                ? _c(
                                    "Submenu",
                                    { attrs: { name: "report" } },
                                    [
                                      _c(
                                        "template",
                                        {
                                          attrs: { id: "bi_report" },
                                          slot: "title"
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: { type: "md-grid" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm._f("t")("bi_report"))
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.report_list, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "MenuItem",
                                          {
                                            key: index,
                                            attrs: {
                                              name: item.report_name,
                                              to:
                                                "/Report?url=" +
                                                _vm.encodeUrl(item.report_url)
                                            }
                                          },
                                          [
                                            _c("Icon", {
                                              attrs: { type: "md-grid" }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(item.report_name))
                                            ])
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.is_login ? "loginbg" : "action",
              staticStyle: { height: "100%" },
              style: _vm.isCollapsed
                ? "padding-left: 80px"
                : "padding-left: 210px;"
            },
            [_c("router-view")],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.user_info_detail.user_code
        ? _c("litter_helper", { ref: "litter_helper" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 